export default __webpack_public_path__ + "static/media/cris_sq.5cf7e08c.jpg";